'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _throttle2 = require('lodash/throttle');

var _throttle3 = _interopRequireDefault(_throttle2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _screenfull = require('screenfull');

var _screenfull2 = _interopRequireDefault(_screenfull);

var _themeProvider = require('@spp/theme-provider');

var _irisPropTypes = require('@spp/iris-prop-types');

var _AutoplayOverlay = require('./components/AutoplayOverlay');

var _AutoplayOverlay2 = _interopRequireDefault(_AutoplayOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window, document */

var videoIdCounter = 0;

var removeNode = function removeNode(nodeId) {
    var node = document.getElementById(nodeId);

    if (node && node.parentNode) {
        node.parentNode.removeChild(node);
    }
};

var initialState = {
    error: false,
    currentAssetId: null,
    nextAssetId: null,
    showAutoplayOverlay: false
};

var VideoAsset = function (_PureComponent) {
    (0, _inherits3.default)(VideoAsset, _PureComponent);

    function VideoAsset(props) {
        (0, _classCallCheck3.default)(this, VideoAsset);

        var _this = (0, _possibleConstructorReturn3.default)(this, (VideoAsset.__proto__ || (0, _getPrototypeOf2.default)(VideoAsset)).call(this, props));

        _this.player = null;
        _this.playerReady = false;
        _this.videoNodeId = '';
        _this.playCount = 0;

        _this.handleRef = _this.handleRef.bind(_this);
        _this.handleInscreen = _this.handleInscreen.bind(_this);
        _this.playNextVideo = _this.playNextVideo.bind(_this);
        _this.cancelOverlay = _this.cancelOverlay.bind(_this);
        _this.getCurrentAsset = _this.getCurrentAsset.bind(_this);

        _this.state = initialState;
        return _this;
    }

    (0, _createClass3.default)(VideoAsset, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.throttledScrollHandler = (0, _throttle3.default)(this.handleInscreen, 100);
            window.addEventListener('scroll', this.throttledScrollHandler);
            this.initVideoPlayer();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // Before the player is ready, nothing we do below would make sense
            if (!this.playerReady) {
                return;
            }

            var playerIsPlaying = ['playing', 'adPlaying'].includes(this.player.getState());
            if (playerIsPlaying) {
                if (nextProps.currentVideoNodeId !== this.videoNodeId) {
                    if (this.props.shouldVideoPause(nextProps.currentVideoStartMode)) {
                        this.player.pause();
                    }
                    return;
                }

                if (nextProps.forcePause) {
                    this.player.pause();
                }
            }

            // If another video starts when we are counting down, cancel the overlay
            if (this.state.showAutoplayOverlay && nextProps.currentVideoNodeId !== this.videoNodeId) {
                this.setState({ showAutoplayOverlay: false });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            // If we have a entirely new videoAsset, we need to reinit the player
            if (prevProps.videoAsset.id !== this.props.videoAsset.id) {
                this.cleanup();
                this.setState(initialState); // eslint-disable-line
                this.initVideoPlayer();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.cleanup();
            window.removeEventListener('scroll', this.throttledScrollHandler);
        }
    }, {
        key: 'getCurrentAsset',
        value: function getCurrentAsset() {
            var _props = this.props,
                videoAsset = _props.videoAsset,
                fetchedVideos = _props.fetchedVideos;
            var currentAssetId = this.state.currentAssetId;

            // If we have a currentAssetId, it means we are in autoplaynext-mode.
            // Otherwise, use the initial video data.

            if (currentAssetId) {
                return fetchedVideos[currentAssetId] && fetchedVideos[currentAssetId].videoAsset;
            }
            return videoAsset;
        }
    }, {
        key: 'initVideoPlayer',
        value: function initVideoPlayer() {
            var _this2 = this;

            var _props2 = this.props,
                videoAsset = _props2.videoAsset,
                startMode = _props2.startMode,
                videoPlayerUrl = _props2.videoPlayerUrl,
                antiAdblock = _props2.antiAdblock,
                antiAdblockConfigUrl = _props2.antiAdblockConfigUrl,
                autoplayNextLimit = _props2.autoplayNextLimit,
                apiUrl = _props2.apiUrl,
                getPlayerConfig = _props2.getPlayerConfig,
                setupPlayer = _props2.setupPlayer,
                inArticle = _props2.inArticle;


            if (process.env.NODE_ENV !== 'production' && this.props.autoplayNext && !apiUrl) {
                // eslint-disable-next-line no-console
                console.warn('AutoplayNext functionality requires apiUrl to be set');
            }
            var autoplayNext = this.props.autoplayNext && apiUrl;
            this.startMode = startMode;

            var videoNodeId = 'VideoAsset-' + videoIdCounter + '-' + videoAsset.id;
            videoIdCounter += 1;
            this.videoNodeId = videoNodeId;

            var videoPlayer = document.createElement('div');
            videoPlayer.id = videoNodeId;
            this.videoWrapper.appendChild(videoPlayer);

            var config = {
                videoPlayerUrl: videoPlayerUrl,
                antiAdblock: antiAdblock,
                antiAdblockConfigUrl: antiAdblockConfigUrl,
                videoAsset: videoAsset,
                getPlayerConfig: getPlayerConfig,
                inArticle: inArticle,
                autoplayNext: autoplayNext,
                startMode: startMode,
                node: this.videoNodeId,
                getCurrentAsset: this.getCurrentAsset
            };

            var createPlayer = require('./create-player').default; // eslint-disable-line

            createPlayer(config).then(function (player) {
                player.on('ready', function () {
                    // If this doesn't match, it could mean the async-inited player is
                    // no longer relevant, props have changed
                    if (videoNodeId !== _this2.videoNodeId) {
                        player.remove();
                        removeNode(videoNodeId);
                        return;
                    }

                    _this2.playerReady = true;

                    if (_this2.startMode === 'silent') {
                        if (window.SVP.Player.canDeviceAutoplay() !== 'never') {
                            _this2.playerInView = false;
                            _this2.handleInscreen();
                        } else {
                            _this2.startMode = 'manual';
                        }
                    }
                });

                player.on('initialPlay play assetPlay adPlay', function () {
                    // If player ever tries to play, when supposed to be paused, stay paused
                    if (_this2.props.forcePause || _this2.startMode === 'silent' && !_this2.playerInView) {
                        _this2.player.pause();
                    } else {
                        _this2.props.onVideoStarted(_this2.videoNodeId, _this2.startMode);
                    }
                });

                // Setup logic needed for AutoplayNext-functionality
                if (autoplayNext) {
                    player.on('assetPlay', function () {
                        // Customizable max of videos autoplayed in a row
                        if (autoplayNextLimit && _this2.playCount >= autoplayNextLimit) {
                            return;
                        }

                        var nextAssetId = _this2.getCurrentAsset().nextAssetId;

                        if (nextAssetId) {
                            _this2.props.fetchVideo(nextAssetId);
                            _this2.setState({ nextAssetId: nextAssetId });
                        }
                    });

                    player.on('complete', function () {
                        var nextAssetId = _this2.state.nextAssetId;

                        // If document.hidden is available and false, don't queue autoplaynext

                        if (document.hidden === true) {
                            return;
                        }

                        if (nextAssetId && _this2.props.fetchedVideos[nextAssetId]) {
                            _this2.setState({ showAutoplayOverlay: true });
                        }

                        _this2.playCount = _this2.playCount + 1;
                    });
                }

                // Optional additional player setup
                if (setupPlayer) {
                    setupPlayer(player, {
                        getCurrentVideoAsset: _this2.getCurrentAsset,
                        startMode: _this2.startMode
                    });
                }

                _this2.player = player;
            }).catch(function () {
                _this2.setState({ error: true });
            });
        }
    }, {
        key: 'cleanup',
        value: function cleanup() {
            if (this.player) {
                if (this.playerReady) {
                    this.player.remove();
                    removeNode(this.videoNodeId);
                }
                this.player = null;
                this.playerReady = false;
                this.videoNodeId = '';
                this.playCount = 0;
            }
        }
    }, {
        key: 'handleRef',
        value: function handleRef(ref) {
            this.videoWrapper = ref;
        }

        /*
        - before the player is ready, ignore the inscreen handler
        - If showing the autoplayOverlay, and user scrolls out, cancel the overlay
        - If not showing the overlay and video is complete, we won't toggle play/pause
        - If the video is not startMode:silent, we won't toggle play/pause
        (Once we move away from "autoplaying" videos, the last one should probably apply to all videos)
        */

    }, {
        key: 'handleInscreen',
        value: function handleInscreen() {
            if (!this.playerReady) return;

            var inView = this.isElementInView();

            if (this.state.showAutoplayOverlay && !inView) {
                this.setState({
                    showAutoplayOverlay: false
                });
                return;
            }

            if (this.player.getState() === 'complete' || this.startMode !== 'silent') return;

            if (inView && !this.playerInView) {
                this.playerInView = true;
                this.player.play();
            } else if (!inView && this.playerInView) {
                this.playerInView = false;
                this.player.pause();
            }
        }
    }, {
        key: 'isElementInView',
        value: function isElementInView() {
            if (_screenfull2.default.element && _screenfull2.default.element.id === this.videoNodeId) {
                return true;
            }

            var HEADER_OFFSET = this.props.headerOffset; // Compensate for sticky headers
            var rect = this.videoWrapper.getBoundingClientRect();
            var INVIEW_OFFSET = rect.height * 0.7; // 70% of video allowed outside when starting
            var WINDOW_HEIGHT = window.innerHeight || document.documentElement.clientHeight;

            return rect.top + INVIEW_OFFSET - HEADER_OFFSET >= 0 && rect.bottom - INVIEW_OFFSET <= WINDOW_HEIGHT;
        }
    }, {
        key: 'playNextVideo',
        value: function playNextVideo() {
            var fetchedVideos = this.props.fetchedVideos;
            var nextAssetId = this.state.nextAssetId;


            if (nextAssetId && fetchedVideos[nextAssetId]) {
                this.player.playNext(parseInt(nextAssetId, 10));

                this.setState({
                    currentAssetId: nextAssetId,
                    nextAssetId: null,
                    showAutoplayOverlay: false
                });
            }
        }
    }, {
        key: 'cancelOverlay',
        value: function cancelOverlay() {
            this.setState({
                nextAssetId: null,
                showAutoplayOverlay: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                theme = _props3.theme,
                genericErrorMsg = _props3.genericErrorMsg,
                autoplayNextLabel = _props3.autoplayNextLabel,
                autoplayNextCountdown = _props3.autoplayNextCountdown,
                fetchedVideos = _props3.fetchedVideos,
                imageAsset = _props3.imageAsset;
            var _state = this.state,
                error = _state.error,
                showAutoplayOverlay = _state.showAutoplayOverlay,
                nextAssetId = _state.nextAssetId;


            if (error) {
                return _react2.default.createElement(
                    'div',
                    { className: theme.root },
                    _react2.default.createElement(
                        'div',
                        { className: theme.error },
                        genericErrorMsg
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: theme.root, 'data-test-tag': '@spp/video-asset' },
                _react2.default.createElement('div', { className: theme.player, ref: this.handleRef }),
                showAutoplayOverlay && fetchedVideos[nextAssetId] && _react2.default.createElement(_AutoplayOverlay2.default, {
                    title: fetchedVideos[nextAssetId].videoAsset.title,
                    label: autoplayNextLabel,
                    countdownTime: autoplayNextCountdown,
                    imageAsset: fetchedVideos[nextAssetId].imageAsset,
                    bgImageAsset: imageAsset,
                    playVideo: this.playNextVideo,
                    cancel: this.cancelOverlay,
                    theme: theme
                })
            );
        }
    }]);
    return VideoAsset;
}(_react.PureComponent);

VideoAsset.propTypes = {
    videoAsset: _irisPropTypes.objects.videoAsset.isRequired,
    imageAsset: _irisPropTypes.objects.imageAsset.isRequired,
    startMode: _propTypes2.default.oneOf(['manual', 'auto', 'silent']),
    getPlayerConfig: _propTypes2.default.func.isRequired,
    setupPlayer: _propTypes2.default.func,
    forcePause: _propTypes2.default.bool,
    shouldVideoPause: _propTypes2.default.func,
    currentVideoStartMode: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
    autoplayNext: _propTypes2.default.bool,
    autoplayNextLabel: _propTypes2.default.string,
    autoplayNextCountdown: _propTypes2.default.number,
    autoplayNextLimit: _propTypes2.default.number,
    inArticle: _propTypes2.default.bool,
    videoPlayerUrl: _propTypes2.default.string,
    antiAdblock: _propTypes2.default.bool,
    antiAdblockConfigUrl: _propTypes2.default.string,
    apiUrl: _propTypes2.default.string,
    headerOffset: _propTypes2.default.number,
    currentVideoNodeId: _propTypes2.default.string.isRequired, // eslint-disable-line
    fetchedVideos: _propTypes2.default.object.isRequired, // eslint-disable-line
    fetchVideo: _propTypes2.default.func.isRequired,
    onVideoStarted: _propTypes2.default.func.isRequired,
    genericErrorMsg: _propTypes2.default.string,
    theme: _propTypes2.default.shape({
        root: _propTypes2.default.string,
        player: _propTypes2.default.string,
        error: _propTypes2.default.string
    })
};
VideoAsset.defaultProps = {
    startMode: 'manual',
    setupPlayer: undefined,
    videoPlayerUrl: undefined,
    antiAdblock: false,
    antiAdblockConfigUrl: undefined,
    apiUrl: undefined,
    forcePause: false,
    autoplayNext: false,
    autoplayNextLabel: undefined,
    autoplayNextCountdown: undefined,
    autoplayNextLimit: undefined,
    inArticle: true,
    headerOffset: 0,
    genericErrorMsg: 'Error when loading video',
    theme: {},
    shouldVideoPause: function shouldVideoPause() {
        return true;
    },
    currentVideoStartMode: undefined
};
exports.default = (0, _themeProvider.themer)('@spp/video-asset')(VideoAsset);
//# sourceMappingURL=VideoAsset.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/video-asset/lib/cjs/VideoAsset.js
 ** module id = 705
 ** module chunks = 1
 **/